import apiHandler from "../core/apiHandler";

const ticketsPdfApi = apiHandler('pdf/tickets');
export default ticketsPdfApi;
